import { faCircleInfo, faHeartPulse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';

const AwardsForm = () => {
    const navigate = useNavigate();

    const goBack = () => navigate(-1);

    return (
        <section>
            <div className="max-w-2xl mx-auto p-6 space-y-8 text-portal-dark-blue">
                <h1 className='text-[#41264B] text-2xl font-semibold border-b border-[#41264B]'>Awards</h1>
                <section className="pb-6">
                    <div className="border border-blue-400 bg-blue-50 text-blue-800 p-4 rounded-lg flex items-start gap-3">
                        <FontAwesomeIcon icon={faCircleInfo} className="mt-1 text-lg" />
                        <p className="text-sm">
                            You must not use this service for emergencies or urgent conditions, as this may delay necessary treatment.
                        </p>
                    </div>

                    <div className="mt-6">
                        <h3 className="text-xl font-semibold text-[#41264B] mb-2">How it works</h3>
                        <p className="text-[#41264B] whitespace-pre-line">Our Awards Programme recognises and supports schools in building a culture of health and wellbeing.</p>
                    </div>

                    <div className="space-y-4 mt-4">
                        <div className="flex items-start gap-3 text-sm text-gray-300">
                            <FontAwesomeIcon icon={faHeartPulse} className="text-[#407cb9] mt-1" />
                            <p>
                                <span className="text-[#407cb9] font-semibold">Structured Framework:</span>
                                <span className='text-[#41264B]'> A clear path to plan, deliver, and measure wellbeing initiatives in your school</span>
                            </p>
                        </div>
                        <div className="flex items-start gap-3 text-sm text-gray-300">
                            <FontAwesomeIcon icon={faHeartPulse} className="text-[#407cb9] mt-1" />
                            <p>
                                <span className="text-[#407cb9] font-semibold">Whole-School Engagement:</span>
                                <span className='text-[#41264B]'> Involve staff, pupils, and families in promoting physical and emotional wellbeing</span>
                            </p>
                        </div>
                        <div className="flex items-start gap-3 text-sm text-gray-300">
                            <FontAwesomeIcon icon={faHeartPulse} className="text-[#407cb9] mt-1" />
                            <p>
                                <span className="text-[#407cb9] font-semibold">Guided Support:</span>
                                <span className='text-[#41264B]'> Expert advice to help your school embed sustainable wellbeing practices</span>
                            </p>
                        </div>
                        <div className="flex items-start gap-3 text-sm text-gray-300">
                            <FontAwesomeIcon icon={faHeartPulse} className="text-[#407cb9] mt-1" />
                            <p>
                                <span className="text-[#407cb9] font-semibold">Celebration of Success:</span>
                                <span className='text-[#41264B]'> Recognize and showcase your school's commitment through certification and awards</span>
                            </p>
                        </div>
                        <div className="flex items-start gap-3 text-sm text-gray-300">
                            <FontAwesomeIcon icon={faHeartPulse} className="text-[#407cb9] mt-1" />
                            <p>
                                <span className="text-[#407cb9] font-semibold">Continuous Improvement:</span>
                                <span className='text-[#41264B]'> Tools and resources to support long-term development and measurable impact</span>
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center justify-between space-x-4">
                        <button
                            onClick={() => window.open("https://schooladvice.co.uk/leadership-support/awards-and-programmes", '_blank')}
                            className='w-full py-2 rounded font-semibold mt-4 border-2 transition-all bg-white text-[#41264B] hover:shadow-lg hover:border-[#41264B] hover:bg-[#e6e3ea]'
                        >
                            More Info
                        </button>
                        <button
                            type="button"
                            onClick={goBack}
                            className="w-full bg-gray-300 text-gray-800 py-2 rounded font-semibold mt-4 hover:bg-white border-2 border-gray-300"
                        >
                            Cancel
                        </button>
                    </div>
                </section>
            </div>
        </section>
    );
};

export default AwardsForm;